import React, { useLayoutEffect } from 'react'
import { useParams } from "react-router";
import { getFormattedDate } from '../../../common/date';
import Table from '../../../components/Common/Table';
import TableNoRecords from '../../../components/Common/Table/TableNoRecords';
import Pagination from '../../../components/Pagination'
import { Context } from '../../../config/store';
import LenderUgroService from '../../../services/lender';
import FundoutBulkModal from './BulkfundoutModal'
import fundoutbulktable from './fundoutbulktable'
import './styles.css'

const Fundoutbulkupload = () => {
  const { state } = React.useContext(Context);
  const leadId = useParams().id;

  const [tableData, setTableData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [modalState, setModalState] = React.useState(false);
	const [pagination, setPaginationData] = React.useState({});
	const [page, setPage] = React.useState(1);

  const toggleModal = () => {
    setModalState(!modalState)
  }
  useLayoutEffect(() => {
    getbulkfundoutList()
  }, [page])
  const getbulkfundoutList = async () => {
    setLoading(true);
    setError(false);
    setErrorMessage("");
    try {
      const response = await LenderUgroService.getbulkfundoutList(page);
      const data = response.data.data?.fundout_files?.data;
      const pagination_data =  response.data.data?.fundout_files?.pagination;
      setPaginationData(pagination_data || {})
      // console.log(data)
      setTableData(data);
      setLoading(false);
    } catch (err) {
      setError(true);
      setErrorMessage(
        err.response?.data?.messages?.error?.form[0] ||
        err.response?.data?.messages?.error?.others[0] ||
        "Failed to load bulk found detail"
      );
    }
  };
  return (
    <div>
      <div className='mt-3'>
        <span className='heading  text-underline'>Upload bulk Fundout</span>
      </div>
      <>

        <div className="row no-gutters justify-content-between align-items-center mt-3">
          <div></div>
          <div className="mb-2">
            <button className="btn btn-custom btn-custom-height" onClick={toggleModal}>
              Add Bulk Fundout
            </button>
            {modalState && (
              <FundoutBulkModal
                userType={state.userType}
                state={modalState}
                toggleModal={toggleModal}
                leadId={leadId}
                reloadTable={getbulkfundoutList}
              />
            )}
          </div>
        </div>
        {!error ? (
          <div className="bulkfundout_table_css">
            <Table
              columns={fundoutbulktable}
              checkbox={false}
              rows={tableData}
              loading={loading}
              // type="paymentData"
              tableExtraClass={""}
              reloadTable={getbulkfundoutList}
            >
            </Table>
          </div>
        ) : (
          <div className="text-center table-error-message mt-4">
            <p>{errorMessage}</p>
          </div>
        )}
        <Pagination
					setPage={setPage}
					total_pages={pagination?.total_pages}
					total={pagination?.total}
				/>
      </>
    </div>
  )
}

export default Fundoutbulkupload



